var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"duplicate-job mt-4"},[_c('h1',{staticClass:"pt-4 mb-0"},[_vm._v("Duplicates created")]),_vm._v(" "),_c('b-container',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-block"},[(!_vm.result)?_c('div',[_vm._v("Loading results...")]):_vm._e(),_vm._v(" "),(_vm.result)?_c('product-list',{attrs:{"results":_vm.result}}):_vm._e()],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b39c12cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DuplicateJob.vue
// module id = MKRu
// module chunks = 1